module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/doub.31015c99.png";